// src/checkout/UpgradeSuccess.jsx

import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Fade } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

function AnimatedCheck() {
  const [show, setShow] = useState(false);
  useEffect(() => { setTimeout(() => setShow(true), 200); }, []);

  return (
    <Box
      sx={{
        width: 64,
        height: 64,
        borderRadius: '50%',
        bgcolor: 'success.main',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: show ? 'scale(1)' : 'scale(0)',
        opacity: show ? 1 : 0,
        transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
      }}
    >
      <CheckIcon sx={{ fontSize: 32, color: '#fff' }} />
    </Box>
  );
}

export default function UpgradeSuccess({ tier, offer, onDone }) {
  const selected = offer || tier || {};
  const highlights = Array.isArray(selected.features) ? selected.features : selected.highlights || [];
  const [showContent, setShowContent] = useState(false);
  useEffect(() => { setTimeout(() => setShowContent(true), 500); }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: 400,
        mx: 'auto',
        px: 4,
        py: 5,
      }}
    >
      <AnimatedCheck />

      <Fade in={showContent} timeout={600}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <Typography sx={{ fontSize: 24, fontWeight: 700, textAlign: 'center', mt: 2.5, mb: 0.75 }}>
            Upgrade complete!
          </Typography>
          <Typography sx={{ fontSize: 14, color: 'text.secondary', textAlign: 'center', mb: 3.5 }}>
            Your upgrade is active for this yearbook.
          </Typography>

          {/* Unlocked features */}
          <Box
            sx={{
              width: '100%',
              p: 2.5,
              borderRadius: 4,
              bgcolor: 'grey.50',
              border: 1,
              borderColor: 'divider',
              mb: 3.5,
            }}
          >
            <Typography sx={{ fontSize: 13, fontWeight: 600, mb: 1.5 }}>Now available:</Typography>
            {highlights.map((h, i) => (
              <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.75 }}>
                <CheckIcon sx={{ fontSize: 15, color: 'success.main' }} />
                <Typography sx={{ fontSize: 13, color: 'grey.700' }}>{h}</Typography>
              </Box>
            ))}
          </Box>

          <Button fullWidth variant="contained" size="large" onClick={onDone} sx={{ py: 1.7, fontSize: 15 }}>
            Back to Yearbook
          </Button>
        </Box>
      </Fade>
    </Box>
  );
}
